import React from 'react';
import { IFlatEndorsementFeeData } from 'types/administration/pricing/underwriterProfileInterfaces/IFlatEndorsementFee';
import { Grid } from 'ui-toolkit/components';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { humanizeEndorsement } from 'utilities/shared/stringMethods/humanizeEndorsement';

interface IFlatEndorsementFeeViewerProps {
  endorsements: IFlatEndorsementFeeData[];
}

export const FlatEndorsementFeeViewer: React.FC<IFlatEndorsementFeeViewerProps> = ({ endorsements }) => (
  <Grid>
    {endorsements.map((endorsement) => (
      <LabelValueViewer
        key={endorsement.name + endorsement.fee}
        label={`${humanizeEndorsement(endorsement.name)} Fee`}
        value={endorsement.fee}
        templateColumns={'1fr 2fr'}
      />
    ))}
  </Grid>
);
